export default __webpack_public_path__ + "226bf4bc1e36143d1ceea5aa12b1a7b8.svg";